import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { ComponentsModule } from 'src/app/components/components.module';
import { GameHistoryComponent } from './game-history.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { DateTimestampFormatPipe } from 'src/app/pipes/date-timestamp-format.pipe';
@NgModule({
    declarations: [
        GameHistoryComponent
    ],
    imports: [
        CommonModule,
        IonicModule,
        ReactiveFormsModule,
        ComponentsModule,
        NgxPaginationModule,
        DateTimestampFormatPipe,
    ],
})
export class CasinoHistoryPageModule { }
